import { Outlet } from '@remix-run/react'

import { cn } from '~/utils/classnames'

export default function ProductLayout() {
  return (
    <div
      className={cn(
        'bg-background min-h-full',
        '@lg:grid @lg:h-full @lg:grid-rows-[var(--inner-page-top-nav-height)_1fr] @lg:rounded-t-[inherit]'
      )}
    >
      <Outlet />
    </div>
  )
}
